import { createSlice } from "@reduxjs/toolkit";
import NavInitialState from "../../Variables/NavState";

const NavSlice = createSlice({
  name: "nav1",
  initialState: NavInitialState,
  reducers: {
    updateQuickSearchResults: (state, action) => {
      state.quickSearchResults = action.payload;
    },
    toggleQuickSearchingFlag: (state, action) => {
      state.quickSearchingFlag = action.payload;
    },
    updateQuickSearchInput: (state, action) => {
      state.quickSearchInput = action.payload;
    },
    setContextMenuOpen: (state, action) => {
      state.contextMenuOpen = action.payload;
    },
  },
});

export const {
  updateQuickSearchResults,
  toggleQuickSearchingFlag,
  updateQuickSearchInput,
  setContextMenuOpen,
} = NavSlice.actions;
export default NavSlice.reducer;
